var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let Rating = class Rating extends Vue {
    constructor() {
        super(...arguments);
        this.currentRating = 0;
    }
    mounted() {
        this.currentRating = this.rating || 0;
    }
    setRating(rating) {
        if (this.isEditable) {
            this.currentRating = rating;
            this.$emit('ratingChanged', this.currentRating);
        }
    }
    ratingChanged(newRating, oldRating) {
        if (newRating !== oldRating) {
            this.currentRating = newRating;
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], Rating.prototype, "rating", void 0);
__decorate([
    Prop({ default: 24 }),
    __metadata("design:type", Number)
], Rating.prototype, "size", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], Rating.prototype, "isEditable", void 0);
__decorate([
    Watch('rating'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], Rating.prototype, "ratingChanged", null);
Rating = __decorate([
    Component({})
], Rating);
export default Rating;
